<template>
  <div v-if="viewMCGEmployeeYearAwards" class="idea-challenges">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <!--<ContentHeader :name="award.title.rendered"></ContentHeader>-->
        <ContentHeader name="MCG EMPLOYEE of the Year"></ContentHeader>
        <section>
          <div class="card mb-3">
            <div v-if="award._embedded['wp:featuredmedia'] !== undefined" class="featuredImg">
              <img v-if="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                :src="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                :alt="award._embedded['wp:featuredmedia'][0].alt_text"
                :title="award._embedded['wp:featuredmedia'][0].title.rendered"
              >
            </div>
            <div v-if="award.include_nomination_form[0] === 'Yes'" v-html="award.content.rendered" class="card-body px-3 pb-0"></div>
            <div class="px-3 pb-3">
              <h4 class="mb-3">{{NominationLabel}}</h4>
            </div>
            <div v-if="award.nomination_event_time_frame.length > 0">
              <ul class="fa-ul" v-if="award.nomination_event_time_frame[0][0][0].nomination_event_date_from !== ''">
                <li class="h6">
                  <span class="fa-li"><i class="fas fa-calendar-alt fa-fw fa-sm text-black-50"></i></span>
                  {{award.nomination_event_time_frame[0][0][0].nomination_event_date_from}} -
                  {{award.nomination_event_time_frame[0][0][0].nomination_event_date_to}}
                </li>
              </ul>
            </div>

            <!-- <ChildNominationEventsList v-if="award.child_nomination_awards.length > 0 && award.child_nomination_awards[0] !== []" class="px-3 pb-3" :awards="award.child_nomination_awards[0][0]" name="The awards categories are:"></ChildNominationEventsList> -->
            <div v-if="madeNomination" class="px-3 pb-3">
              <div class="alert alert-success" role="alert">
                Congratulations, you've nominated:
                <ul>
                  <li v-for="teams in NominationTeamNames" v-bind:key="teams.email">
                    <strong>{{teams.name}}</strong> from {{teams.country}} -
                    Employee number: <strong>{{teams.employeeNum}}</strong><br>
                    GOM: <strong>{{teams.GOM}}</strong><br>
                    Selection: <strong>{{teams.option}}</strong><br>
                  </li>
                </ul>
              </div>
              <!--button type="button" name="button" class="btn btn-primary" v-on:click="removeNominee()">Nominate someone else</button-->
            </div>
            <div v-if="award.include_nomination_form[0] === 'Yes' && award.nomination_fields.length > 0 && !madeNomination && displayForm" class="px-3 pb-3">
              <PreContentHeader :show-loading="searchingForEmployee" :error-message="searchingForEmployeeError"></PreContentHeader>
              <div class="p-3 mb-2 bg-primary text-white border border-primary font-weight-bold mt-1" v-if="NominationTeamNames.length === 1"></div>
              <transition name="grow">
                <div>
                  <hr>
                  <form v-on:submit.prevent=""><!-- Added OnSubmit; after few plugins update issues -->
                    <div v-for="formField in nominationFields" v-bind:key="formField.index">
                      <template v-if="formField.description === 'MCG Employee of the Year Motivation'">
                        <NominationField
                          :type="formField.type"
                          :description="formField.description"
                          :secondary-description="formField.secondaryDescription"
                          :description-lvl-two="formField.description_lvl_two"
                          :secondary-description-lvl-two="formField.secondary_description_lvl_two"
                          :is-required="formField.isRequired"
                          :checkbox-labels="formField.checkboxLabels"
                          v-on:updatedFieldContent="fieldUpdated($event)"
                          :validationMethod="formField.validationMethod"
                          :displayField="formField.display_field"
                          :options="formField.options"
                          :error-class="formField.errorClass"
                          :labelContent="selectedNomineeOption"
                          :defaultText="nominatedComments">
                        </NominationField>
                      </template>
                      <template v-else>
                        <NominationField
                          :type="formField.type"
                          :description="formField.description"
                          :secondary-description="formField.secondaryDescription"
                          :description-lvl-two="formField.description_lvl_two"
                          :secondary-description-lvl-two="formField.secondary_description_lvl_two"
                          :is-required="formField.isRequired"
                          :checkbox-labels="formField.checkboxLabels"
                          v-on:updatedFieldContent="fieldUpdated($event)"
                          :validationMethod="formField.validationMethod"
                          :displayField="formField.display_field"
                          :options="formField.options"
                          :nomineeLabels="formField.nomineeLabels"
                          :error-class="formField.errorClass"
                          :labelContent="selectedNomineeOption">
                        </NominationField>
                      </template>
                    </div>
                    <div class="row" style="display:none">
                      <div class="col-md-4 col-lg-4 col-xl-3">
                        <label class="h6 col-md-right text-right"><span>Total</span> 
                          <br> <small class="text-black-50 h6 col-md-right text-right"></small></label>
                      </div> 
                      <div class="col-md-8 col-lg-8 col-xl-9">
                        <div class="form-group clearfix">
                          <div> {{ totalRank }} </div>
                        </div>
                      </div>
                    </div>
                    <div class="row py-1">
                      <div class="col offset-md-4 offset-lg-4 offset-xl-3">
                        <div class="form-group form-check">
                          <input type="checkbox" class="form-check-input" id="terms" v-model="termsCheckbox" required>
                          <label for="terms" class="form-check-label">Nomination Complete. I accept the 
                            <router-link to="/page/multichoice-recognition-terms-and-conditions" target="_blank">Terms &amp; Conditions</router-link>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="row pt-2 mb-4">
                      <div class="col offset-md-4 offset-lg-4 offset-xl-3" v-if="submitClicked">
                        <button @click="submitNomination" type="submit" class="btn btn-primary btn-lg">Submit Nomination</button>
                      </div>
                    </div>
                  </form>
                </div>
              </transition>
              <PreContentHeader :show-loading="creatingNomination" :error-message="createNominationError"></PreContentHeader>
            </div>
            <div v-if="award.include_nomination_form[0] === 'No'">
              <div class="p-4">
                <h4>Form Currently Unavailable</h4>
                <hr>
                <p>We're sorry, but the form you are trying to access is currently unavailable. If you have any questions or concerns, please don't hesitate to contact our HR team for assistance.</p>
              </div>
            </div>
          </div>
        </section>
        <div v-if="award.additional_content.length > 0 && award.additional_content[0] !== '' && award.additional_content !== ''" class="card mb-3">
          <div class="card-body" v-html="award.additional_content[0]"></div>
        </div>
      </div>
    </transition>
  </div>
  <div v-else>
    <!--h5> You do not have permission to access this page. Please contact HR team to provide role.</h5-->
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import ADauthentication from '@/helpers/ADauthentication.js'
import NominationNotification from '@/helpers/NominationNotification.js'
import ChildNominationEventsList from '@/components/ChildNominationEventsList'
import NominationField from '@/components/NominationField'
import Loading from '@/components/Loading'
import PreContentHeader from '@/components/PreContentHeader'
import vueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      award: [],
      errors: [],
      contentReady: false,
      contentLoadError: '',
      nominationContent: [],
      nominationFields: [],
      userDetails: [],
      nominationList: [],
      nomineeData: [],
      selectedNomineeIndex : 0,
      nomineeOptions: [],
      mcgCustomerCareRange: [1,2,3,4,5],
      nominatedPerson: '',
      madeNomination: false,
      displayForm: false,
      selectedNomineeOption: 'Select Nominee',
      WinnerRunnerUpFieldDisplayStatus: false,
      selectWinnerRunnerUpStatus: 'Winner',
      GOMLabel: '',
      selectedBU: '',
      termsCheckbox: false,
      validatedNominee: '',
      showNominationForm: false,
      creatingNomination: false,
      createNominationError: '',
      searchingForEmployee: false,
      searchingForEmployeeError: '',
      isContractorErrorSet: true,
      isTeamAwards: false,
      submitClicked: true,
      NominationButtonText: 'Nominate',
      NominationLabel: 'Nominate an Employee for this Award',
      NominationPlaceholder: 'Search by name and surname or email address...',
      NominationTeamNames: [],
      NominationTeamsContent: [],
      nomineesList: [],
      employeeHierarchy: {},
      options: [],
      selectedOption: '',
      supportingDocList: [],
      supportingDocLength: 0,
      nominatedComments: '',
      customerExperience : 1,
      revenue: 1,
      cost: 1,
      brandValue: 1,
      totalRank: 4,
      totalWinnerCount : 0,
      totalRunnerupCount: 0,
      MCGEOYBUNominationID: '',
      nomineeLabels: [],
      MCGEOYOption1: '',
      MCGEOYOption2: '',
      MCGEOYOption3: ''
    }
  },
  components: {
    PreContentHeader,
    ContentHeader,
    ChildNominationEventsList,
    NominationField,
    Loading,
    vueBootstrapTypeahead
  },
  computed: {
    ...mapGetters([
      'viewMCGEmployeeYearAwards'
    ])
  },
  methods: {
    displaySelectForm: function() {
      if (this.selectWinnerRunnerUpStatus == 'Winner') {
        if (this.totalWinnerCount >= 3) {
          //alert(`The MCG EOY nomination already has three Winner nominations. A fourth Winner cannot be nominated.`)
          //this.displayForm = false
          //return false
        }
      }
      this.displayForm = true
      for(let index = 0; index < this.nomineeOptions.length; index++) {
        if (this.nomineeOptions[index] === this.selectedNomineeOption) {
          this.selectedNomineeIndex = index
          this.selectedBU = this.nomineeData[this.selectedNomineeIndex]['BU'][0]
          this.MCGEOYBUNominationID = this.nomineeData[this.selectedNomineeIndex].id
          this.updatedNominationField()
          this.setValidatedNominee(this.nomineeData[this.selectedNomineeIndex]['nomineeDetails']['employeehierarchy'], this.nomineeData[this.selectedNomineeIndex]['email'])
          //this.setNominationContent()
          break
        }
      }
    },
    updatedNominationField: function() {
      for (var j = 0; j < this.nominationFields.length; j++) {
        if (this.nominationFields[j].description === 'HCBP') {
          let HRBPData = this.nomineeData[this.selectedNomineeIndex].teamnominationworkflow[0].filter(x=> x.project_sponsor_name === 'HRBP')
          if (HRBPData && HRBPData[0] && HRBPData[0]['project_sponsor_email']) {
            this.nominationFields[j].options = HRBPData[0]['project_sponsor_email']
          }
        }
      }
    },
    fieldUpdated: function (fieldDetails) {
      for (var i = 0; i <= this.nominationContent.length; i++) {
        if (this.nominationContent[i].label === fieldDetails.label) {
          this.nominationContent[i].content = fieldDetails.content
          this.nominationContent[i].validated = fieldDetails.validated
          this.nominationContent[i].displayField = fieldDetails.displayField
          if (this.nominationContent[i].label == "FieldMCGTemplate") {
            console.log('fieldUpdated this.nominationContent[i].label 349', i, this.nominationContent[i], this.nominationContent[i].label, fieldDetails.label, this.nominationContent[i].content)
            this.selectedOption = this.nominationContent[i].content
          }
          break
        }
      }
    },
    setNominationContent: function (nominationFields) {
      var self = this
      self.nominationFields = nominationFields.map(function (x, index) {
        var displayFieldVal = x.display_field === "No" ? false : true
        var nomineeOptions = []
        var WinnerRunnerUpLabel = []
        if (self.nomineeOptions ) {
          nomineeOptions = self.selectedNomineeOption
        }
        if (x.form_field_type == "FieldMCGTemplate") {
          return {
            type: x.form_field_type,
            description: x.field_description,
            secondaryDescription: x.field_secondary_description,
            isRequired: x.required_nomination_field,
            checkboxLabels: x.checkbox_labels,
            errorClass: '',
            index: index + x.form_field_type,
            description_lvl_two: x.description_lvl_two,
            secondary_description_lvl_two: x.secondary_description_lvl_two,
            display_field: displayFieldVal,
            validationMethod: x.validationmethod,
            options: self.nomineeOptions,
            nomineeLabels: self.nomineeLabels
          }
        } else {
          return {
            type: x.form_field_type,
            description: x.field_description,
            secondaryDescription: x.field_secondary_description,
            isRequired: x.required_nomination_field,
            checkboxLabels: x.checkbox_labels,
            errorClass: '',
            index: index + x.form_field_type,
            description_lvl_two: x.description_lvl_two,
            secondary_description_lvl_two: x.secondary_description_lvl_two,
            display_field: displayFieldVal,
            validationMethod: x.validationmethod
          }
        }
      })
      if (self.nominationContent.length > 1) {
        self.nominationContent = self.nominationFields.map(function (x, i) {
          return {label: x.description, content: self.nominationContent[i].content, required: x.isRequired, validated: false, displayField: x.displayField}
        })
      } else  {
        self.nominationContent = self.nominationFields.map(function (x) {
          return {label: x.description, content: '', required: x.isRequired, validated: false, displayField: x.displayField}
        })
      }
    },
    setValidatedNominee: function (userData, email) {
      userData.employeeHierarchy = userData
      userData.email = email
      if (this.checkForDuplicateNominee(userData)) {
        this.validatedNominee = {
          name: userData["first-name"][0] + ' ' + userData["last-name"][0],
          slug: userData.email.replace(/\./g, '-').replace(/@/g, '').toLowerCase(),
          department: userData.departmentname[0],
          company: (userData.company === '') ? 'Multichoice' : userData["company"][0],
          employeeNum: userData.employeenumber[0],
          country: userData.country[0],
          email: userData.email,
          lineManagerName: userData.employeeHierarchy['line-manager-name'][0],
          lineManagerEmail: userData.employeeHierarchy['line-manager-email'][0],
          employeeHierarchy: userData.employeeHierarchy
        }
        this.NominationTeamNames[0] = this.validatedNominee
        this.getPageLabel()
      }
    },
    // code to get Label of page
    getPageLabel: function() {
      this.NominationLabel = "MCG Employee Of The Year Nomination"
    },
    exportContentData: function (data) {
      var chunks = data[0].split(' @#$% ')
      var header = ''
      var value = ''
      var exportData = []
      chunks.map(function (val, index) {
        if (val.indexOf('<h>') > -1) {
          header = val.replace(/<h>/g, '').replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, '').replace(/<br>/g, ' ').replace(/<br\/>/g, ' ').replace(/,/g, ';')
        }
        if (val.indexOf('<c>') > -1) {
          value = val.replace(/<c>/g, '').replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, '').replace(/<br>/g, ' ').replace(/<br\/>/g, ' ').replace(/,/g, ';').replace(/ /g, ' ').replace(/ /g, ' ').replace(/ /g, ' ')
          exportData[header] = value
        }
      })
      return exportData
    },
    getWinnerDetails: async function () {
      try {
        const response = await WordpressRestAPI.getCustomViewContent('thinktank_authentication/v1/getWinnerDetailsEOY')
        console.log('getWinnerDetails review list-> ', this.userDetails.email, response.data, response.data.winner_list, response.data.winner_list.length, this.award.nomination_fields[0][0])
        if (response.data && response.data) {
          if (response.data.nominations) {
            //this.nominationList = response.data.nominations
            console.log('getWinnerDetails response.nominations.length ', response.data.nominations.length)
            if (response.data.total_winner_count) {
              this.totalWinnerCount = response.data.total_winner_count
            }
            let MCG_nominee_list = []
            if (response.data.MCG_nominee_list) {
              MCG_nominee_list = response.data.MCG_nominee_list
            }
            let user_index = 0;
            for(let index = 0; index < response.data.nominations.length; index++) {
              if (response.data.nominations[index].nominee_slug[1] && response.data.nominations[index].nominee_slug['employeehierarchy']) {
                this.nomineeOptions[user_index] = response.data.nominations[index].nominee_slug[1]

                this.nomineeLabels[user_index] = []
                this.nomineeLabels[user_index]['email'] = response.data.nominations[index].nominee_slug[1]
                this.nomineeLabels[user_index]['GOM'] = response.data.nominations[index].BUEOYGOM[0]
                this.nomineeLabels[user_index]['Link'] = WordpressRestURI.frontEndDomain + "my-profile/review-bu-employee-award/" + response.data.nominations[index].id
                this.nomineeLabels[user_index]['FullName'] = response.data.nominations[index].nominee_slug['employeehierarchy']['first-name'][0] + ' ' + response.data.nominations[index].nominee_slug['employeehierarchy']['last-name'][0]
                
                this.nomineeData[user_index] = []
                this.nomineeData[user_index]['nomineeDetails'] = response.data.nominations[index].nominee_slug
                this.nomineeData[user_index]['nomineeDetails']['employeehierarchy']['company'] = response.data.nominations[index].nominee_company
                this.nomineeData[user_index]['email'] = response.data.nominations[index].nominee_slug[1]
                this.nomineeData[user_index]['BU'] = response.data.nominations[index].BUEOYBUField
                this.nomineeData[user_index]['GOM'] = response.data.nominations[index].BUEOYGOM
                this.nomineeData[user_index]['country'] = response.data.nominations[index].nominee_slug['employeehierarchy'].country
                this.nomineeData[user_index]['company'] = response.data.nominations[index].nominee_company
                this.nomineeData[user_index]['AddedDocumentID'] = response.data.nominations[index]["AddedDocumentID"]
                this.nomineeData[user_index]['id'] = response.data.nominations[index].id
                this.nomineeData[user_index]['teamnominationworkflow'] = response.data.nominations[index].teamnominationworkflow
                let splitData = this.exportContentData(response.data.nominations[index].nominationdata)
                if (splitData && splitData['Detailed Motivation']) {
                  this.nomineeData[user_index]['nominatedComments'] = splitData['Detailed Motivation']
                }
                user_index++
              }
            }
          }
          this.award.nomination_fields[0][0][1].options = this.nomineeOptions
          //this.nomineeOptions = response.data.BU
          this.showNominationForm = true
          this.searchingForEmployee = false
        }
      } catch (e) {
        this.contentLoadError = 'Currently, there are no nominations for the BU Award. Please proceed by nominating a BU Award Winner. Once completed, we can select MCG Award nominees from the BU Award Winners.';
        console.error(e);
        this.contentReady = true;
      }
    },
    setNomineeEOY: function () {
      const SelectedOptions = this.nominationContent[14].content
      let userData = []
      console.log(' SelectedOptions ', SelectedOptions, this.selectedOption)
	    var selected = false
      let optionIndex = 0
      for (let index = 0; index < this.nomineeData.length; index++) {
        for (const [email, option] of Object.entries(SelectedOptions)) {
          if (email.toLowerCase() === this.nomineeOptions[index].toLowerCase()) {
            optionIndex = 0
            selected = false
            console.log(`Match found for ${email} => Selected option: ${option}`);
            userData = this.nomineeData[index]['nomineeDetails']['employeehierarchy']
            userData['email'] = []
            userData['email'][0] = this.nomineeOptions[index]
            console.log(' userData ', userData, userData.email)
            selected = false
            if (option == 'option1') {
              this.MCGEOYOption1 = {'email': email, 'id' : this.nomineeData[index]['id'], 'GOM': this.nomineeData[index]['GOM'][0]}
              optionIndex = 1
              selected = true
            }
            if (option == 'option2') {
              this.MCGEOYOption2 = {'email': email, 'id' : this.nomineeData[index]['id'], 'GOM': this.nomineeData[index]['GOM'][0]}
              optionIndex = 2
              selected = true
            }
            if (option == 'option3') {
              this.MCGEOYOption3 = {'email': email, 'id' : this.nomineeData[index]['id'], 'GOM': this.nomineeData[index]['GOM'][0]}
              optionIndex = 3
              selected = true
            }
            if (selected) {
	            this.validatedNominee = {
	              name: userData['first-name'][0] + ' ' + userData['last-name'][0],
	              slug: userData['email'][0].replace(/\./g, '-').replace(/@/g, '').toLowerCase(),
	              department: userData['departmentname'][0],
	              company: (userData.company === '') ? 'Multichoice' : userData["company"][0],
	              employeeNum: userData['employeenumber'][0],
	              country: userData['country'][0],
	              email: userData['email'][0],
	              lineManagerName: userData['line-manager-name'][0],
	              lineManagerEmail: userData['line-manager-email'][0],
	              employeeHierarchy: userData,
	              GOM: this.nomineeData[index]['GOM'][0],
	              option: option,
                optionIndex: optionIndex                
	            }
	            this.NominationTeamNames.push(this.validatedNominee)
            }
          }
        }
      }
      console.log('setNomineeEOY this.NominationTeamNames ', this.NominationTeamNames)
    },
    // Below code is to remove all members. This function is used for Nominate someone else
    removeNominee: function () {
      window.location.reload()
      this.validatedNominee = {name: '', department: '', employeeNum: ''}
      this.showNominationForm = false
      this.madeNomination = false
      this.NominationTeamNames = []
      this.submitClicked = true
      this.nominationContent = []
      this.termsCheckbox = false
      this.createNominationError = ''
      this.searchingForEmployeeError = ''
      this.setNominationContent(this.award.nomination_fields[0][0])
    },
    // Remove single user
    removeTeamNominee: function (index) {
      this.NominationTeamNames.splice(this.NominationTeamNames.indexOf(index), 1)
      if (this.NominationTeamNames.length === 0) {
        this.showNominationForm = false
      }
      this.getPageLabel()
      var slugArray = this.NominationTeamNames.map(function(member) {
          return member.slug;
      });
      // Convert the 'emailArray' to a string with a comma as the separator
      var slugString = slugArray.join(',')
      if (slugString) {
        this.submitClicked = true
      }
    },
    setPostContent: function (type,label) {
      var content = ''
      var plainContent = ''
      for (var i = 0; i < this.nominationContent.length; i++) {
        if (this.nominationContent[i].displayField) {
          if (this.nominationContent[i].label === label) {
            content += '<strong>' + this.nominationContent[i].label + '</strong><br><p>' + this.nominationContent[i].content + '</p>'
            plainContent += '<h>' + this.nominationContent[i].label + '<h> @#$% <c>' + this.nominationContent[i].content + '<c> @#$% '
          }
        }
      }
      return (type === 'nohtml' ? plainContent : content)
    },
    ValidateFields: function (value, type, label) {
      if (type.toLowerCase() === 'email') {
        if (value.indexOf('@') === -1 || value.indexOf('.') === -1) {
          alert('Invalid ' + label + ' !')
          return false
        } else if (value.split('@').length > 2) {
          alert ('Only one mail allowed for ' + label + ' !' )
          return false
        }
        return true
      }
    },
    assignUserCommunities: function () {
      const userCommunityIDstring = this.$store.getters.getUserCommunityIDstring;
      if (userCommunityIDstring) {
        return this.award.community_categories.filter(
          f => userCommunityIDstring.split(',').map(x => parseInt(x)).includes(f)
        );
      } else {
        return [] // Return an empty array if userCommunityIDstring is undefined or empty
      }
    },
    getNominationEventCategory: function () {
      var nominationEventCategory = []
      nominationEventCategory.push('20')
      nominationEventCategory.push('140')
      return nominationEventCategory
    },
    getNominationTitle: function () {
      var self = this
      var nominationTitle = self.validatedNominee.name + ', MCG Employee of the Year'
      return nominationTitle
    },
    submitNomination: function () {
      if (this.readyToSubmitNomination()) {
        this.createNominationEntry()
      } else {
        this.submitClicked = true
      }
    },
    // code to check Nomination Field and Nomination Content for validation
    readyToSubmitNomination: function () {
      var contentPassedValidation = true
      this.searchingForEmployeeError = ''
      for (var j = 0; j < this.nominationContent.length; j++) {
        this.nominationFields[j].errorClass = ''
        console.log(' nominationFields ', this.nominationFields[j], this.nominationContent[j])
        if (this.nominationFields[j].display_field === false || this.nominationFields[j].description == 'Total' || this.nominationFields[j].description == 'GOM' || this.nominationFields[j].description == 'Supporting Documentation Link') {
          continue
        } else {
          if (this.nominationFields[j].validationMethod) {
            contentPassedValidation = this.ValidateFields(this.nominationContent[j].content, this.nominationFields[j].validationMethod, this.nominationContent[j].label)
          }
          if (this.nominationContent[j].required === 'false' && this.nominationContent[j].content === '' && !this.nominationContent[j].validated) {
            this.nominationContent[j].validated = true
          }
          if (this.nominationContent[j].validated === false) {
            contentPassedValidation = false
            this.nominationFields[j].errorClass = 'field-not-validated'
          }

          if (this.nominationContent[j].label == "FieldMCGTemplate") {
            const SelectedOptions = this.nominationContent[j].content
            const selectedCount = Object.keys(SelectedOptions).length
            console.log(' SelectedOptions ', SelectedOptions, selectedCount)
            if (selectedCount < 3) {
              alert(' All options need to be selected ')
              return false // Stops further execution
            }
          }
        }
      }
      console.log('readyToSubmitNomination this.termsCheckbox ', this.termsCheckbox, contentPassedValidation, 'result ', this.termsCheckbox && contentPassedValidation)
      return this.termsCheckbox && contentPassedValidation
    },    
    // Below code is for submitting Nomination form
    createNominationEntry: function () {
      this.setNomineeEOY()
      this.showNominationForm = false
      this.creatingNomination = true
      var self = this
      if (self.$store.state.UserProfile.currentUser.meta.communities !== undefined && self.$store.state.UserProfile.currentUser.meta.communities.length > 0) {
        var employeeCompany = self.$store.state.UserProfile.currentUser.meta.communities
      } else {
        var employeeCompany = self.validatedNominee.department
      }
      if (self.$store.state.UserProfile.currentUser.meta.employeeNumber !== undefined && self.$store.state.UserProfile.currentUser.meta.employeeNumber.length > 0) {
        var employeeNumber = self.$store.state.UserProfile.currentUser.meta.employeeNumber
      } else {
        var employeeNumber = self.validatedNominee.employeeNum
      }
      self.NominationTeamNames.sort((a, b) => a.optionIndex - b.optionIndex)      
      var sendNomination = {
        method: 'POST',
        data: {
          title: self.getNominationTitle(),
          nomination_event_category: self.getNominationEventCategory(),
          community_categories: self.assignUserCommunities(),
          nomination_approve_decline: 'Accepted',
          nominee_name: self.validatedNominee.name,
          nominee_slug: self.validatedNominee.slug,
          nominee_company: self.validatedNominee.company,
          status: 'publish',
          content: self.setPostContent('html','MCG Employee of the Year Motivation'),
          nominationdata: self.setPostContent('nohtml','MCG Employee of the Year Motivation'),
          winnerRunnerStatus: self.selectWinnerRunnerUpStatus,
          MCGEOYGOM: self.GOMLabel,
          BUEOYBUField: self.selectedBU,
          MCGEOYBUNominationID: self.MCGEOYBUNominationID,
          MCGEOYCustomerExperience: self.customerExperience,
          MCGEOYRevenue: self.revenue,
          MCGEOYCost: self.cost,
          MCGEOYBrandValue: self.brandValue,
          MCGEOYTotalRank: self.totalRank,
          nominator_details: [{
            'employee-number': employeeNumber,
            'employee-company': employeeCompany
          }],
          MCGEOYExco2Data: self.setPostContent('nohtml','Exco Comments'),
          MCGEOYOption1: self.MCGEOYOption1,
          MCGEOYOption2: self.MCGEOYOption2,
          MCGEOYOption3: self.MCGEOYOption3
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }

      sendNomination.data.teamnominationworkflow = []
      var d = new Date()
      let nominationDate = d.getFullYear() + '-' + parseInt(parseInt(d.getMonth()) + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
      console.log('createNominationEntry self.NominationTeamNames[0].employeeHierarchy ', self.NominationTeamNames)
      console.log('createNominationEntry self.NominationTeamNames[0].employeeHierarchy ', self.NominationTeamNames, self.NominationTeamNames[0].employeeHierarchy)

      // Push Line Manager
      if (self.NominationTeamNames && self.NominationTeamNames[0] && self.NominationTeamNames[0].employeeHierarchy && self.NominationTeamNames[0].employeeHierarchy['line-manager-email'] && self.NominationTeamNames[0].employeeHierarchy['line-manager-email'][0]) {
        sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'Manager', 'project_sponsor_email': self.NominationTeamNames[0].employeeHierarchy['line-manager-email'][0], 'project_sponsor_comment': '', 'project_sponsor_status': 'Approve', 'project_sponsor_datetime' : nominationDate})
      } else {
        sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'Manager', 'project_sponsor_email': '', 'project_sponsor_comment': '', 'project_sponsor_status': 'Approve', 'project_sponsor_datetime' : nominationDate})  
      }

      // Push Exco2 Manager
      if (self.NominationTeamNames && self.NominationTeamNames[0] && self.NominationTeamNames[0].employeeHierarchy && self.NominationTeamNames[0].employeeHierarchy['exco2-email'] && self.NominationTeamNames[0].employeeHierarchy['exco2-email'][0]) {
        sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'Exco2', 'project_sponsor_email': self.NominationTeamNames[0].employeeHierarchy['exco2-email'][0], 'project_sponsor_comment': '', 'project_sponsor_status': 'Approve', 'project_sponsor_datetime' : nominationDate})
      } else {
        sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'Exco2', 'project_sponsor_email': '', 'project_sponsor_comment': '', 'project_sponsor_status': 'Approve', 'project_sponsor_datetime' : nominationDate})
      }

      // Push HRBP
      if (self.NominationTeamNames && self.NominationTeamNames[0] && self.NominationTeamNames[0].employeeHierarchy && self.NominationTeamNames[0].employeeHierarchy['hrbp-email'] && self.NominationTeamNames[0].employeeHierarchy['hrbp-email'][0]) {
        sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'HRBP', 'project_sponsor_email': self.NominationTeamNames[0].employeeHierarchy['hrbp-email'][0], 'project_sponsor_comment': '', 'project_sponsor_status' : 'Approve', 'project_sponsor_datetime': nominationDate})
      } else {
        sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'HRBP', 'project_sponsor_email': '', 'project_sponsor_comment': '', 'project_sponsor_status' : 'Approve', 'project_sponsor_datetime': nominationDate})
      }

      if (self.NominationTeamNames.length > 1) {
        sendNomination.data.isteamaward = 'true'
      }
      if (self.NominationTeamNames.length > 1) {
        sendNomination.data.nominationteam = []
        sendNomination.data.nominee_name = ''
        sendNomination.data.nominee_slug = ''
        for (var i = 0; i < self.NominationTeamNames.length; i++) {
          sendNomination.data.nominationteam.push({
            'member_name': self.NominationTeamNames[i].name,
            'member_approve_reject': 'Accepted',
            'member_company': self.NominationTeamNames[i].company,
            'member_employee_number': self.NominationTeamNames[i].employeeNum,
            'member_slug': self.NominationTeamNames[i].slug,
            'email': self.NominationTeamNames[i].email
          })
        }
      }
      WordpressRestAPI.endpointWithAuthetication(sendNomination, 'nomination')
      .then(function (response) {
        self.sendEmailNotificationToNominator(response.data)
        self.madeNomination = true
        self.creatingNomination = false
      })
      .catch(function (e) {
        self.createNominationError = 'Oops! We had a problem adding your nomination. Please try again later.'
        console.error(e)
      })
    },
    sendEmailNotificationToNominator: function (nomination) {
      var self = this
      var d = new Date()
      let nominationDate = d.getFullYear() + '-' + parseInt(parseInt(d.getMonth()) + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
      let ccMail = 'Ruksanah.Ally@multichoice.co.za,halecia.naicker@mnet.co.za,ThinkTank@multichoice.co.za'
      let reviewLink = WordpressRestURI.frontEndDomain + 'login/my-profile+review-nomination-mcg-employee-award+'+nomination.id
      let emailBody = NominationNotification.confirmationOfMCGEOYNominationBody({
        nominator: this.$store.getters.getUserName,
        nominationDate: nominationDate,
        NominationTeamNames: self.NominationTeamNames,
        reviewLink: reviewLink
      })

      var emailNominationNotification = {
        method: 'POST',
        data: {
          to: 'ThinkTank@multichoice.co.za',
          cc: ccMail,
          subject: 'MCG Employee of the Year',
          message: emailBody
        },
        json: true
      }

      WordpressRestAPI.sendEmail(emailNominationNotification)
      .then(function (response) {
        console.log(response.data)
        self.sendEmaiCallDone = true
        console.log(' sendEmaiCallDone done ', self.sendEmaiCallDone)
      })
      .catch(function (e) {
        console.error(e)
      })
    },
    loadContent: function () {
      this.madeNomination = false
      this.nominatedPerson = ''
      document.title = this.$route.name + ' - ThinkTank'
      WordpressRestAPI.getViewContent('nomination_event?nomination_event_category=140&_embed&per_page=1')
      .then(response => {
        console.log('loadContent response.data ', response.data)
        this.award = response.data[0]
        console.log('loadContent this.award ', this.award, this.award.content.rendered)
        var self = this
        self.getWinnerDetails()
        .then(() => {
          console.log('Nominations fetching complete.');
          self.contentReady = true
          if (self.award.include_nomination_form[0] === 'Yes') {
            // Reinitiate every variable related with form
            self.NominationTeamNames = []
            self.NominationButtonText = 'Add Nominee'
            self.NominationLabel = 'MCG Employee of the year'
            self.NominationPlaceholder = 'Search by email address, seperate multiple email by comma...'
            self.setNominationContent(this.award.nomination_fields[0][0])
            self.displaySelectForm()
          }
        })
        .catch(error => {
          console.error('Error:', error);
          // Handle the error if needed
        });
      })
      .catch(e => {
        this.contentLoadError = 'Oops! We had a problem with loading this Recognition. Please try again later.'
        console.error(e)
        this.contentReady = true
      })
    },
    searchNomineeList: function (newQuery) {
      if ( newQuery.length > 2 )
      WordpressRestAPI.getCustomViewContent('getNominees/v1/nomineelist?search=' + newQuery)
      .then((res) => {
        this.nomineesList = res.data
      })
    },
  },
created () {
  document.title = this.$route.name + ' - ThinkTank'
  var self = this
  var usernameOptions = {
    method: 'GET',
    headers: {
      'Authorization': localStorage.getItem('userToken'),
      'Content-Type': 'application/json'
    },
    json: true
  }
  WordpressRestAPI.endpointWithAuthetication(usernameOptions, 'users/me?context=edit')
    .then(function (userResponse) {
      self.userDetails = userResponse.data
      if (self.userDetails) {
        console.log(' self.userDetails ', self.userDetails)
        console.log(' self.userDetails ', self.userDetails.email)

        self.loadContent()
      }
  })
  .catch(e => {
      console.error(e)
  })
},
watch: {
  nominatedPerson (newQuery, oldQuery) { 
    if (newQuery != '')
      this.searchNomineeList(newQuery) 
  },
  '$route' (to, from) {
    this.contentReady = false
    this.loadContent()
  }
}
}
</script>

<style lang="less">
.featuredImg {
  img {
    width: 100%;
  }
}
.box {.icon { text-align: center; position: relative; }}
.box { .icon { .image { position: relative; z-index: 2; width: 50px; height: 50px; line-height: 50px; border-radius: 50%; background: #09ced6; vertical-align: middle; }}}
.box { .icon:hover { .image { background: #63B76C; }}}
.box { .icon { .image { i { color: #fff !important; border: 1px solid white; padding: 10px; border-radius: 50%; min-width: 38px;}}}}
.box { .icon { .info { margin-top: -45px; margin-left: 20px; padding: 15px 20px 10px 0px; }}}
.box { .icon { .infoaqua { background-color:#CEF6F8; }}}
.box { .icon { .infogrey { background-color:#F8F8F8; }}}
.box { .icon { .infowhite { background-color:#FFFFFF; }}}
.box { .icon { .info { h3 { font-weight: 500;  margin: 0 0 0 50px; text-align: left; color: #09ced6; }}}}
.box { .icon { .info { h5 { font-weight: 500;  margin: 0 0 0 50px; text-align: left; color: #09ced6; }}}}
.box { .icon { .info { ul {list-style: none; margin-left: 20px;}}}}
.box { .icon { .info { ul { li::before { content: "\2022"; color: #09ced6; display: inline-block; width: 1em; margin-left: -1em;}}}}}
.box { .icon { .info { .miniseparator {width: 55px; border-bottom: 5px solid #09ced6; margin-left: 50px;}}}}
.box { .icon { .info { p {margin-left: 40px;}}}}
.aquacolor {color:#09ced6;}
.navycolor {color: navy;}
</style>


// WEBPACK FOOTER //
// src/components/routes/VEAwardsMCGEmployeeYear.vue